// extracted by mini-css-extract-plugin
export default {"container":"_d7o4m0","headerWrapper":"_1lezf6l","appLogo":"_1hxc6ir","closeButton":"_19n8uw1"};